import { getMessage } from '../api/validation-errors';
/**
 * Handles API validation errors by mapping them to form fields
 *
 * @param form - The React Hook Form instance
 * @param validationErrors - Array of validation errors returned from API
 * @returns The original validation errors array
 *
 * @example
 * ```
 * const login = useLoginApi({
 *   onSuccess: () => navigate('/dashboard'),
 *   onError: (errors) => handleFormErrors(form, errors)
 * });
 * ```
 */
export const handleFormErrors = (form, validationErrors) => {
    validationErrors.forEach((error) => form.setError(error.path.join('.'), {
        type: 'manual',
        message: getMessage(error),
    }));
    return validationErrors;
};
